import { http } from '@/shared/api/http'


export async function getActiveCarousel() {
  const response = await http.get('/homepage/carousel')
  return response.data
}

export async function getCarouselItemById(id) {
  const response = await http.get(`/homepage/carousel/${id}`)
  return response.data
}


export async function getAllCarouselItems() {
  const response = await http.get('/admin/homepage/carousel')
  return response.data
}

export async function createCarouselItem(data) {
  const response = await http.post('/admin/homepage/carousel', data)
  return response.data
}

export async function updateCarouselItem(id, data) {
  const response = await http.put(`/admin/homepage/carousel/${id}`, data)
  return response.data
}

export async function deleteCarouselItem(id) {
  const response = await http.delete(`/admin/homepage/carousel/${id}`)
  return response.data
}

export async function reorderCarouselItems(itemOrders) {
  const response = await http.patch('/admin/homepage/carousel/reorder', { itemOrders })
  return response.data
}